export type { ConsumableLifetimeCycleProps } from './consumable-lifetime-cycle';
export * from './consumable-lifetime-cycle.routes';

export { default as ConsumableLifetimeCycle, default } from './consumable-lifetime-cycle';
